import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Location', path: '/location' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled || menuOpen
          ? 'bg-white border-b border-rdr-cream-dark'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20 lg:h-24">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <img
            src={
              scrolled || menuOpen
                ? 'https://images.squarespace-cdn.com/content/v1/5ff52abbfe6e8d5e4781b57a/178a510b-eff1-46e7-901b-5799d2db414b/Red+Door+Ranch+%281%29.png'
                : 'https://images.squarespace-cdn.com/content/v1/5ff52abbfe6e8d5e4781b57a/1609977666561-KA61GJFJSQ1HY463YCNR/Red-Door-Ranch-Horizontal+White.png'
            }
            alt="Red Door Ranch — Luxury Wedding Venue in Joshua TX"
            className="h-9 w-auto object-contain transition-all duration-500"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-xs font-medium tracking-[0.18em] uppercase transition-colors duration-300 ${
                scrolled
                  ? 'text-rdr-charcoal hover:text-rdr-gold'
                  : 'text-white/85 hover:text-white'
              } ${location.pathname === link.path ? (scrolled ? 'text-rdr-gold' : 'text-white') : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right side */}
        <div className="hidden lg:flex items-center gap-5">
          <a
            href="tel:+18175048501"
            className={`text-xs font-medium tracking-wide transition-colors duration-300 ${
              scrolled ? 'text-rdr-charcoal hover:text-rdr-gold' : 'text-white/70 hover:text-white'
            }`}
          >
            (817) 504-8501
          </a>
          <Link
            to="/location#contact"
            className="bg-rdr-gold text-white text-xs font-medium tracking-[0.18em] uppercase px-6 py-3 hover:bg-rdr-gold-light transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Book a Tour
          </Link>
        </div>

        {/* Mobile Burger */}
        <button
          className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i
            className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl ${
              scrolled || menuOpen ? 'text-rdr-charcoal' : 'text-white'
            }`}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-rdr-cream-dark px-6 py-8 flex flex-col gap-5">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-sans text-sm tracking-[0.18em] uppercase transition-colors cursor-pointer ${
                location.pathname === link.path ? 'text-rdr-gold' : 'text-rdr-charcoal hover:text-rdr-gold'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="h-px bg-rdr-cream-dark my-1" />
          <a
            href="tel:+18175048501"
            className="font-serif text-rdr-charcoal text-xl hover:text-rdr-gold transition-colors cursor-pointer"
          >
            (817) 504-8501
          </a>
          <Link
            to="/location#contact"
            className="bg-rdr-gold text-white text-xs font-sans tracking-[0.18em] uppercase px-6 py-4 text-center hover:bg-rdr-gold-light transition-colors whitespace-nowrap cursor-pointer"
          >
            Book a Private Tour
          </Link>
        </div>
      )}
    </header>
  );
}
